import React, { useState, useRef } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
// import { FaBars, FaTimes } from 'react-icons/fa';
import { IoMenuOutline, IoCloseOutline } from 'react-icons/io5';

import CSIO_2021_Annual_Report_Lo from '../../assets/CSIO_2021_Annual_Report.pdf';
import headerLogo from '../../assets/images/headerLogo.png';

// polyfilled smooth scrolling for IE, Edge & Safari
const smoothScrollTo = (to, duration) => {
  const element = document.scrollingElement || document.documentElement,
    start = element.scrollTop,
    change = to - start,
    startDate = +new Date();

  // t = current time
  // b = start value
  // c = change in value
  // d = duration
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  const animateScroll = _ => {
    const currentDate = +new Date();
    const currentTime = currentDate - startDate;
    element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    }
    else {
      element.scrollTop = to;
    }
  };
  animateScroll();
};

const Header = ({ HEADER_HEIGHT, showHeaderLogo, foo, transparentHeader, isMobile, whiteLink = false, width }) => {
  const dropdownRef = useRef(null);
  const [menuIsVisible, setMenuIsVisible] = useState(false);
  const isIE = window.navigator.userAgent.indexOf("MSIE") > 0 || !!window.navigator.userAgent.match(/Trident.*rv:11\./)

  const scrollWithOffset = (el) => {
    setTimeout(() => {
      const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
      const yOffset = -120;
      if (isIE) {
        smoothScrollTo(yCoordinate + yOffset, 500);
      } else {
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
      }
    }, 250);

  }

  const toggleDropdownMenu = () => {
    if (menuIsVisible) {
      dropdownRef.current.classList.remove('animateDropdown');
      setMenuIsVisible(false);
    } else {
      dropdownRef.current.classList.add('animateDropdown');
      setMenuIsVisible(true);
    }
  };

  return (
    <header
      aria-label="Main site navigation header."
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingRight: isMobile ? 40 : 142,
        paddingLeft: isMobile ? 20 : 142,
        paddingTop: 60,
        position: 'absolute',
        top: 0,
        width: '100%',
        // backgroundColor: showHeaderLogo ? 'white' : 'transparent',
        backgroundColor: 'transparent',
        zIndex: 2,
        height: HEADER_HEIGHT,
      }}>
      {/* <Link className="jumpnav" smooth to="#content-start" scroll={el => scrollWithOffset(el)}>
          Skip to main content
            </Link> */}
      <div style={{
        width: 150,
      }}>
        <button
          aria-label="Menu"
          aria-expanded={menuIsVisible}
          onClick={toggleDropdownMenu} style={{
            backgroundColor: 'white',
            border: 'none',
            borderRadius: 10
          }}>
          <IoMenuOutline size={50} color="#12183A" />
        </button>
      </div>
      {
        !isMobile && showHeaderLogo && !foo && (
          <a
            href="https://www.csio.com/"
            target="_blank"
            rel="noreferrer"
            aria-label="Navigate to CSIO homepage in new tab"
            style={{
              height: HEADER_HEIGHT,
              paddingTop: 8,
              paddingBottom: 8,
            }}>
            <img
              src={headerLogo}
              style={{
                height: '100%',
                width: 'auto'
              }}
              alt=""
            />
          </a>
        )}
      <div style={{
        height: HEADER_HEIGHT,
        paddingTop: 8,
        paddingBottom: 8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <a className="headerDownloadPdfLink" aria-label="Download the annual report pdf" href={CSIO_2021_Annual_Report_Lo} download style={{ color: whiteLink ? 'white' : null }}>
          DOWNLOAD PDF
        </a>
      </div>
      <div
        ref={dropdownRef}
        className="dropdownMenu"
        style={{
          paddingLeft: isMobile ? 20 : 142
        }}
      >
        <button
          aria-label="Menu"
          aria-expanded={menuIsVisible}
          onClick={toggleDropdownMenu}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            // marginTop: 16,
            marginBottom: 16
          }}>
          <IoCloseOutline size={50} color="white" />
        </button>
        <Link
          aria-label="Navigate to top of home page"
          className="headerNavLink"
          to="/#top"
          onClick={toggleDropdownMenu}
        >
          HOME
        </Link>
        <Link aria-label="Navigate to 2021 Highlights section of home page" className="headerNavLink" to="/#2021-highlights" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          2021 Highlights
        </Link>
        <Link aria-label="Navigate to the message from president and ceo page" className="headerNavLink" to="/message-from-president-and-ceo#top" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          MESSAGE FROM PRESIDENT & CEO
        </Link>
        <Link aria-label="Navigate to message from the chairman page" className="headerNavLink" to="/message-from-chairman#top" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          MESSAGE FROM CHAIRMAN OF THE BOARD
        </Link>
        <Link aria-label="Navigate to who we are section of home page" className="headerNavLink" to="/#who-we-are" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          WHO WE ARE
        </Link>
        <Link aria-label="Navigate to the mission, vision, values section of the home page" className="headerNavSubLink" to="/#who-we-are" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          Our Mission, Vision, Values
        </Link>
        <Link aria-label="Navigate to the members section of the home page" className="headerNavSubLink" to="/#our-members" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          Our Members
        </Link>

        <Link aria-label="Navigate to board of directors section of home page" className="headerNavLink" to="/#board-of-directors" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          BOARD OF DIRECTORS
        </Link>

        <Link aria-label="" className="headerNavLink" to="/leaders-for-standards-and-solutions#top" onClick={toggleDropdownMenu}>
          LEADERS FOR STANDARDS AND SOLUTIONS
        </Link>
        <Link aria-label="" className="headerNavSubLinkNoCap" to="/leaders-for-standards-and-solutions#innotech-and-emerging-technology" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          INNOVATION AND EMERGING TECHNOLOGY (INNOTECH) - BILLING AND CLAIMS eDOCS NOTIFICATIONS
        </Link>
        <Link aria-label="" className="headerNavSubLink" to="/leaders-for-standards-and-solutions#commercial-lines-data-standards" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          Commercial Lines Data Standards
        </Link>
        <Link aria-label="" className="headerNavSubLink" to="/leaders-for-standards-and-solutions#csio-data-standards" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          CSIO Data Standards
        </Link>

        <Link aria-label="" className="headerNavLink" to="/brokers-technology-champions#top" onClick={toggleDropdownMenu}>
          BROKERS' TECHNOLOGY CHAMPIONS
        </Link>
        <Link aria-label="" className="headerNavSubLink" to="/brokers-technology-champions#innotech-and-emerging-technology" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          INNOTECH Application Program Interface (API)
        </Link>
        <Link aria-label="" className="headerNavSubLink" to="/brokers-technology-champions#professional-development" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          Professional Development
        </Link>

        <Link aria-label="" className="headerNavLink" to="/raising-the-bar-on-reliable-services#top" onClick={toggleDropdownMenu}>
          RAISING THE BAR ON RELIABLE SERVICES
        </Link>
        <Link aria-label="" className="headerNavSubLink" to="/raising-the-bar-on-reliable-services#my-proof-of-insurance-mpoi" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          My Proof of Insurance (MPOI)
        </Link>
        <Link aria-label="" className="headerNavSubLinkNoCap" to="/raising-the-bar-on-reliable-services#eDocs" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          eDOCS
        </Link>
        <Link aria-label="" className="headerNavSubLinkNoCap" to="/raising-the-bar-on-reliable-services#CSIOnet" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          CSIOnet
        </Link>
        <Link aria-label="" className="headerNavSubLinkNoCap" to="/raising-the-bar-on-reliable-services#csio-dot-com" smooth scroll={el => scrollWithOffset(el)} style={{ marginTop: 12 }} onClick={toggleDropdownMenu}>
          CSIO.com
        </Link>
        <div style={{
          height: 1,
          backgroundColor: 'white',
          width: '61.8%',
          marginTop: 32,
          marginBottom: 32,
        }}
        />

        <a className="headerDropdownDownloadPdfLink" aria-label="Download the annual report pdf" href={CSIO_2021_Annual_Report_Lo} download>
          DOWNLOAD PDF
        </a>
      </div>
    </header>
  )
}

export default Header;
